<template>

  <div :class="classList" id="app">
    <div v-if="isUnauthorized"
         class="none-authorized-tip">
      <p class="c-p-t-30">{{_$('EBS控制台目前无可用机房，如需进行产品体验')}}</p>
      <h3>{{_$('请联系客服(400-028-9900)')}}</h3>
    </div>
    <div :class="showTittle && inStanceDetail ? 'p-r-24 p-l-24 body-content' : 'body-content'"
         v-else>
      <div class="layout collapsed">
        <div>
            <div class="app-header">
              <div v-if="showTittle && inStanceDetail" class="list-tittle" style="height:52px">
                <Regions
                    class="f-l"
                    :tittleName="tittleName"
                    @changeProjectValue="changeProjectValue"></Regions>
                <a @click="openHelp" v-if="tittleName !== '回收站'" class="f-r">
                  <Icon class="k-icon-paper" style="color: #0091ea" />
                  {{_$('相关文档')}}
                </a>
              </div>
            </div>
            <div style="background-color:#F8F8FA">
                <router-view :regionKey="regionKey" :commonConfig="commonConfig" :ebsPriceInfo="ebsPriceInfo" @getInStanceDetail="inStanceDetail=false" :newRegionsList="newRegionsList" :inStanceDetail="inStanceDetail" :projectValue="projectValue"/>
            </div>
        </div>
      </div>
    </div>
  <!--  占位：解决主机详情页 icon不显示问题  -->
    <Icon style="display: none" />
  </div>

</template>
<script>
import ebsApi from './api/ebsApi';
import commonApi from '@/api/commonApi';
import Regions from './components/regions.vue';
import navList from '../src/utils/navList';
import utils from './utils/utils';
import {initRegion} from '@/utils';
import {DbscConstants, DbscEssdTypeIds} from '@/utils/constants';
import { Menu, MenuItem, Icon } from '@king-design/vue-legacy';
import filters from '@/filters/filter';

export default ({
  name: 'app',
  components: {
    Menu,
    MenuItem,
    Icon,
    Regions

  },
  data () {
    return {
      isUnauthorized: false,//是否存在可用机房
      ebsPriceInfo: {},//价格体系列表
      regionsList: [],//机房列表
      regionKey: utils.getLocalStorageRegion(),//选中的region
      collapse: false,
      navList: navList,
      selectNav: 'volumeList',
      showTittle: false,
      tittleName: '',
      regionShow: false,
      newRegionsList: {},
      projectValue: '',
      // 是否是在主机详情页面，这里写反了，默认应该是 false
      inStanceDetail: true,
      commonConfig:{
        copySnapshotLimit: 10,
        copySnapshotRegion: {},
        setdeleteTimeSnapshotLimit: 10
      },
      loadDbscPermission: false
    };
  },
  methods: {
    changeNav (item) {
      if (item.type === 'outhref') {
        window.location.replace(item.href);
      } else if (item.type === 'myhref') {
        this.$router.push(item.href);
      }
    },
    getEBSPriceInfo () {
      ebsApi.getEBSPriceInfo({
        Flag: false
      }).then(res => {
        if (res.status) {
          let data = res.data.data;
          let ebsPriceInfo = data && data.length > 0 ? data.find(item => item.productGroupId === 101) : [];
        //   this.isUnauthorized = utils.isEmpty(ebsPriceInfo);
          this.ebsPriceInfo = ebsPriceInfo;
          this.$store.commit('setEbsPriceInfo', ebsPriceInfo);
          this.getRegionlist();
        }else{
            if(res.data !== 'sameRequest'){
                this.isUnauthorized = true;
                utils.showErrorTip(res);
            }
        }
      }).catch(err => {
            this.isUnauthorized = true;
            utils.showErrorTip(err);
      });
    },
    //根据价格体系返回获取机房列表
    getRegionlist () {
      let allList = utils.unRegions(this.ebsPriceInfo.productTypeList);
      let regionList = [];
      allList.forEach(element => {
        let {regionId, regionCode, regionName, regionEnName, areaName, areaEnName, areaCode} = { ...element };
        regionList.push({
            regionId, regionCode, regionName, regionEnName, areaName, areaEnName, areaCode
        });
      });
      // 被 iframe 引用
      // 只有回收站、快照、云盘列表，并且不能是详情页 
      if(self !== top && ['recycle', 'snapshotList', 'volumeList'].includes(this.$route.name) && this.$route.query.type !== 'detail'){
        window.parent.postMessage({from: 'ebs', regionList, regionShow: true, region: utils.getLocalStorageRegion()},'*');
        window.localStorage.setItem('regions', JSON.stringify(regionList));
        // this.initSnapCopyRegionList();
        if (this.$route.name === 'recycle' || this.$route.name === 'create') {
          this.checkHasDbscPermission(); // 作为 iframe 时，只有回收站和创盘页面需要 检查是否有 专属集群权限
        }
        this.isUnauthorized = false;
      }else{
        utils.getLocalStorageRegion();
        if (!_.isEmpty(regionList)) {
          this.regionsList = regionList;
          window.localStorage.setItem('regions', JSON.stringify(regionList));
          // this.setRegionKey();
          this.initSelect();
          this.isUnauthorized = false;
        } else {
            this.isUnauthorized = true;
        }
        // 不被主机 iframe 引用时，需要自己设置区域列表
        if (!['create', 'dbscCreate', 'dbscVolumeCreate', 'dbscDetail', 'dbscDetailInfo', 'dbscDetailVolume', 'dbscDetailSnapshot', 'dbscMonitor'].includes( this.$route.name)) {
            initRegion(regionList, utils.getLocalStorageRegion());
        }

        if (self === top) {
          console.log('isNotIframe');
          __ksStorage__.on('region',(key) => {
            this.regionKey = key;
            window.localStorage.setItem('region', key);
            console.log('newkey:', key);
            this.getQueryCommonConfig();
            this.checkHasDbscPermission();
            // this.initSnapCopyRegionList();
          });
        }
        if (utils.getLocalStorageRegion() && utils.getLocalStorageRegion() !== 'null') {
          console.log('utils');
          this.checkHasDbscPermission(); // 检查是否有 专属集群权限
          // this.initSnapCopyRegionList();
        }


      }
    },

    //处理regoin数据
    initSelect() {
        let list = utils.initRegion(this.regionsList);
        this.newRegionsList.asia = list.asia;
        this.newRegionsList.Chinese = list.Chinese;
        this.newRegionsList.European = list.European;
    },
    checkHasDbscPermission() {
      if (!this.ebsPriceInfo.productTypeList) {
        return;
      }
      const dbscProductTypes = this.ebsPriceInfo.productTypeList.filter(item => {
        return DbscConstants.DbscProductTypeIdList.includes(item.productTypeId);
      });
      let dbscRegions = [];
      // 是否包含当前 region 的专属集群权限
      let hasCurrentRegionDbscPermission = false;
      dbscProductTypes.forEach(item => {
        dbscRegions = dbscRegions.concat(item.regionList);
        console.log('item.regionList', item.regionList);
        if (Array.isArray(item.regionList)) {
          item.regionList.some(region => {
            if (region.regionCode === this.regionKey) {
              hasCurrentRegionDbscPermission = true;
              return true;
            }
          });
        }
      });
      console.log('hasCurrentRegionDbscPermission', hasCurrentRegionDbscPermission);
      // 没有权限，检查是否之前创建过专属集群
      if (!hasCurrentRegionDbscPermission && !this.loadDbscPermission) {
        let params = {
          MaxResults: 10,
          Marker: 1
        };
        this.loadDbscPermission = true;
        ebsApi
            .describeDbscList(params)
            .then((res) => {
              this.loadDbscPermission = false;
              const dbscCount = res.data.TotalCount || 0;
              this.$store.commit('setDbscCount', dbscCount);
            }).catch(() => {
              this.loadDbscPermission = false;
            });
      }
      this.$store.commit('setDbscRegion', dbscRegions);
      this.$store.commit('setDbscPermission', hasCurrentRegionDbscPermission);
    },

    // //设置默认region
    // setRegionKey () {
    //     if( !utils.getLocalStorageRegion() || utils.getLocalStorageRegion() === 'null' || (utils.getLocalStorageRegion() && !_.find(this.regionsList, item => {return item.regionCode === utils.getLocalStorageRegion();}))){
    //         let regionKey = this.regionsList[0].regionCode;
    //         utils.setLocalStorage(regionKey);
    //         window.localStorage.setItem('regionKey', regionKey);
    //         this.regionKey = regionKey;
    //     }else{
    //         window.localStorage.setItem('regionKey', utils.getLocalStorageRegion());
    //         this.regionKey =  utils.getLocalStorageRegion();
    //     }
    //     this.regionShow = true;
    //     this.initRegionList();
    // },

    // changeRegionKey(value){
    //     this.regionKey = value;
    //     utils.setLocalStorage(value);
    //     window.localStorage.setItem('regionKey', value);
    // },

    showHead(val){
           // eslint-disable-next-line default-case
           switch (val.name) {
            case 'volumeList': this.tittleName = '硬盘'; this.showTittle = true; this.selectNav = 'volumeList'; break;
            case 'detail': this.tittleName = ''; this.showTittle = false; break;
            case 'recycle': this.tittleName = '回收站'; this.showTittle = true; this.selectNav = 'recycleEbs'; break;
            case 'snapshotList': this.tittleName = '快照'; this.showTittle = true; this.selectNav = 'snapshotList'; break;
            case 'dbscList': this.tittleName = '专属块存储集群'; this.showTittle = false; this.selectNav = 'dbscList'; break;
            case 'create': this.tittleName = ''; this.showTittle = false; this.selectNav = ''; break;
            case 'dbscCreate': this.tittleName = ''; this.showTittle = false; this.selectNav = ''; break;
            case 'dbscDetail': this.tittleName = ''; this.showTittle = false; this.selectNav = ''; break;
            case 'unService': this.tittleName = ''; this.showTittle = false; this.selectNav = ''; break;
        }
    },
    changeProjectValue(value){
        window.localStorage.setItem('projectValue', value);
        this.projectValue = value;
    },
    async getQueryCommonConfig(){
        commonApi.QueryCommonConfig().then(res => {
            if(res.status){
                this.commonConfig = Object.assign(this.commonConfig, JSON.parse(res.data.Result));
                let { helpDocumentList, regionMapList, availabilityZonenList, regionZonenList, instaneType} = this.commonConfig;
                // this.filter.helpDocumentList = helpDocumentList;
                this.filter.regionMapList = regionMapList;
                this.filter.availabilityZonenList = availabilityZonenList;
                this.filter.regionZonenList = regionZonenList;
                this.filter.instaneType = instaneType;
                this.initSnapCopyRegionList();
            } else{
                // utils.showErrorTip(res);
            }
        }).catch(err => {
            // utils.showErrorTip(err);
        });
    },
    async initSnapCopyRegionList(){
        if (!utils.getLocalStorageRegion() || utils.getLocalStorageRegion() === 'null') {
          return;
        }
        commonApi.QuerySnapshotCopyRegionLimits().then(res => {
            if(res.status){
                let regionList =JSON.parse(res.data.Result);
                this.commonConfig = Object.assign(this.commonConfig, {copySnapshotRegion: regionList});
            }
        });
    },
    openHelp(){
      if (this.$route.name === 'snapshotList') {
        utils.gethelpDocument(filters.helpDocument('snapshotList'));
      } else {
        utils.gethelpDocument(filters.helpDocument('volumeList'));
      }
      
    }
  },
  beforeCreate(){
    if(utils.getQueryString('region')){
      utils.setLocalStorage(utils.getQueryString('region'));
    }
  },
  created () {
    utils.getLocalStorageRegion();
    this.getEBSPriceInfo();
    this.getQueryCommonConfig();
    window.addEventListener('message', (event) => {
        // 判断消息来源
        if(event.data.from === 'kec'){
            if(event.data.region){
                console.log('设置 region');
                window.localStorage.setItem('region', event.data.region);
                this.regionKey = event.data.region;
            }
        }
    }, false);
  },
  mounted(){
    this.showHead(this.$route);
    let instanceId = this.$route.path.split('list/')[1];
    if(instanceId){
        this.$router.push({name: 'volumeList', query: { InstanceId: instanceId}});
    }
    if (self === top) {
      setTimeout(() => {
        window.__ksStorage__.docInit({
          indexUrl: '//docs.ksyun.com/products/29',
          indexEnUrl: '//docs.ksyun.com/products/29'
        });
      }, 0);
    }
  },
  watch: {
    '$route': function (val) {
        if(val.query && val.query.type === 'detail'){
            this.inStanceDetail = false;
        }
        this.showHead(val);
        this.getRegionlist();
    }
  },
  computed: {
    classList() {
      return {
        'body-all': true,
        'manage-frame': top === self // 不被 iframe 引用
      };
    }
  }
});
</script>
<style lang="stylus">
@import './common/common.styl'
// v3的 message 需要覆盖 v1的样式
.k-message .k-message-icon
  font-size 16px
.manage-frame {
  padding-top 50px
}
.p-r-24
  padding-right 24px
.p-l-24
  padding-left 24px
.app-header
  background #fff
.body-all
  height 100%
  background-color #F8F8FA
  .body-content
    height 100%
    .layout
      height 100%
      .nav
        position fixed
        z-index 999
        float left
        width 180px
        height 100%
        padding-left 0
        margin-bottom 0
        margin-left 0
        background-color rgb(229, 229, 233)
        transition margin 0.3s ease-in-out
      .nav-link
        position absolute
        top 50%
        right 0
        z-index 5
        height 26px
        padding 0
        color #999
        border-top 3px solid transparent
        border-right 14px solid
        border-bottom 3px solid transparent
        border-right-color #fff
        .icon-show
          position relative
          top 1px
          right -13px
      .nav-header
        display flex
        i
          font-size 22px
      .no-nav
        margin-left -180px
        height 100%
        position fixed
        z-index 3
        float left
        width 180px
        padding-left 0
        margin-bottom 0
        transition margin 0.3s ease-in-out
        .k-menu
          width 0
      .nav-link
        position absolute
        top 50%
        z-index 5
        height 26px
        padding 0
        color #999
        border-right-color #fff
        right -26px
        border-top 3px solid transparent
        border-bottom 3px solid transparent
        border-left 14px solid #e5e5e9
        border-right-width 0
        .icon-hide
          right 13px
          position relative
          top 1px
      .collapse
        margin-left 180px
        height 100%
      .no-collapse
        margin-left 8px
        height 100%
  .none-authorized-tip
    position relative
    top 30%
    left 50%
    width 400px
    margin-left -200px
    font-size 14px
    text-align center
.list-tittle
    padding-top 16px
    height 36px
    margin-bottom 16px
    width calc(100% + 48px)
    position relative
    left -24px
    background #fff
    padding-left 24px
    padding-right 24px

    .k-icon-paper
      position relative
      top 2px

 .inStanceDetail-header
        width 100%
        height 50px
        padding 8px 20px 5px
        font-family PingFangSC-Medium
        line-height 25px
        font-size 14px
        font-weight 500
        color #333333
        background #FFFFFF
        .back
            display inline-block
            margin-right 8px
            vertical-align top
            &:hover
                color #0091ea
.change-task-content {
  &.kd-tooltip-content {
    max-width 500px !important
  }
}

.dialog-content-center
  .k-dialog-body
    .k-alert-dialog-wrapper
      text-align left !important

.k-form-label {
  font-weight normal;
}
.kd-form-label {
  font-weight normal;
}
  
.btn-select {
  display flex
  gap 8px
  flex-wrap wrap

  > button {
    width 155px
    border-radius 4px !important
  }
}
.kd-dialog-footer {
  overflow hidden;
}
.delete-dialog-noHeader {
  .kd-dialog-header {
    display none;
  }
}
.noHeader {
  .kd-dialog-header {
    display none;
  }
}
.btn-link {
  line-height 28px
  color #0091ea
  cursor pointer
  .k-icon {
    color #0091ea
    cursor pointer
    position relative
    top 2px
  }
}
.attach-tooltip {
  width 700px !important;
  &.kd-tooltip-content {
    max-width 700px !important;
  }
}  
</style>
